import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  ElementRef
} from "@angular/core";
import { fuseAnimations } from "../../../../../../../../../../core/animations";
import * as _ from "lodash";
import { MatDialogRef, MatDialog } from "@angular/material";

// Local component
import { ToastComponent } from "../../../../../../../common/toast.component";
import { FuseConfirmDialogComponent } from "../../../../../../../../../../core/components/confirm-dialog/confirm-dialog.component";

// Service file
import { SideNavService } from "../../../../sidenav.service";

// Model & Util
import {
  FileBrowseEvent,
  UploadResponse,
  CreateCopmany,
  FetchCopmany,
  FetchCopmanyNodes,
} from "../../../../../../../models/index";
import {
  checkoutFields,
  apiCalls,
  toastMsg,
  displayValues,
  site,
  spekwo
} from "../../../../../../../utils/index";

@Component({
  selector: "spekwo-company-serve",
  templateUrl: "./company-serve.component.html",
  styleUrls: ["./company-serve.component.scss"],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class CompanyServeComponent implements OnInit {
  checkoutFields = checkoutFields;
  toastMsg = toastMsg;
  displayValues = displayValues;
  apiCalls = apiCalls;
  spekwo = spekwo;
  allBrowsedFiles: FileBrowseEvent[] = [];
  isLogoUpload: boolean = false;

  lastLogoId: number;
  allCompaniesDetail: FetchCopmanyNodes[] = [];
  allCompaniesLogo = [];
  deletArray = [];
  imgviewLoader: boolean = false;
  confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;

  @ViewChild("companyLogo") companyLogo: ElementRef;

  constructor(
    private _sideNavService: SideNavService,
    private _toastComponent: ToastComponent,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.getAllCompaniesLogo();
  }

  getAllCompaniesLogo() {
    this.imgviewLoader = true;
    this._sideNavService
      .fetchAllCompanyLogo()
      .then((alllogos: FetchCopmany) => {
        let res = alllogos && alllogos.data && alllogos.data.allCompanies.nodes;
        this.lastLogoId = res.length > 0 ? res[0].id : 0;
        this.allCompaniesLogo = [];
        _.each(res, data => {
          var companyData = {};
          companyData['checked'] = false;
          companyData['logourl'] = site.apiHost + data.logourl;
          companyData['id'] = data.id;
          this.allCompaniesLogo.push(companyData);
          this.allCompaniesDetail.push(data);
        });
        this.imgviewLoader = false;
      });
  }

  //  Browse files

  onFileChange(event: any) {
    if (event && event.target.files.length > 0) {
      this.allBrowsedFiles = event.target.files;
    }
  }

  //  Clear selected files
  clearFile() {
    this.companyLogo.nativeElement.value = "";
    this.allBrowsedFiles = [];
  }

  //  Submit selected files to backend
  onSubmitFile() {
    this.isLogoUpload = true;
    let count = 0;

    _.each(this.allBrowsedFiles, async (data: FileBrowseEvent) => {
      this.lastLogoId = this.lastLogoId + 1;

      let fileName1 = this.lastLogoId + "_" + data.name;
      let fileName = this.apiCalls.uploadCompanyFolder + "/" + fileName1;

      // Store in db
      await this._sideNavService
        .CreateCompanyLogoOnDb(fileName)
        .then(async (createRes: CreateCopmany) => {
          // let fileName = createRes && createRes.data.createCompany.company.id + '_' + data.name;
          await this._sideNavService
            .fileUpload(data, fileName1, "companyLogo")
            .then(async (res: UploadResponse) => {
              if (res.status == this.checkoutFields.uploadCompanyLogoSuccess) {
                ++count;

                if (count == this.allBrowsedFiles.length) {
                  this._toastComponent.showToast(
                    this.toastMsg.uploadCompanyLogoSuccess
                  );
                  this.isLogoUpload = false;
                  this.allBrowsedFiles = [];
                  this.ngOnInit();
                }
              } else {
                this._toastComponent.showToast(
                  this.toastMsg.uploadCompanyLogoFailed
                );
              }
            })
            .catch(() => {
              this.isLogoUpload = false;
            });
        });
    });
  }

  onChangeCheck(event, companyId) {
    if (event.checked) {
      this.deletArray.push(companyId);
    }
    if (!event.checked) {
      const index: number = this.deletArray.indexOf(companyId);
      if (index !== -1) {
        this.deletArray.splice(index, 1);
      }
    }
  }

  //Deletion functionality
  onDeleteAction() {
    this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
      disableClose: false
    });

    this.confirmDialogRef.componentInstance.confirmMessage = this.displayValues.manageRef.deleteConfirm;
    this.confirmDialogRef.componentInstance.confirmHead = this.displayValues.manageRef.deleteHead;
    this.confirmDialogRef.componentInstance.confirmOkText = this.displayValues.manageRef.deleteOk;
    this.confirmDialogRef.componentInstance.confirmCancelText = this.displayValues.manageRef.deleteCancel;


    this.confirmDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.imgviewLoader = true;
        var index = 0;
        _.each(this.deletArray, (data) => {
          this._sideNavService.
            deleteSelectedCompanyLogoData(data).then((res) => {
              index++;
              if (res) { 
                this._toastComponent.showToast(this.toastMsg.deleteScheSuccess);
              }
              if (index == this.deletArray.length) {
                this.deletArray = [];
                this.getAllCompaniesLogo();
              }
            });
        });
      }
      this.confirmDialogRef = null;
    });


  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/manage-references/company-serve/company-serve.component.ts